import useABTestValue from '@hooks/useABTestValue'

type SharingIconTrackingValueType = 'A' | 'B' | 'C' | 'D'

export type UseGetSharingIconTrackingValue = () => SharingIconTrackingValueType

const useGetSharingIconTrackingValue: UseGetSharingIconTrackingValue = () => {
  const abTestValue = useABTestValue('showSharingIcons')
  const sharingIconTrackingValuesMap: Record<
    string,
    SharingIconTrackingValueType
  > = {
    ColoredGrey: 'C',
    Ghost: 'B',
    Grey: 'D',
    default: 'A',
  }

  return sharingIconTrackingValuesMap[abTestValue || 'default']
}

export default useGetSharingIconTrackingValue
